import React from 'react';
import { UserRole } from '../data/types';
import { PermissionProvider } from '../contexts/PermissionContext';

interface AppPermissionWrapperProps {
  children: React.ReactNode;
  userRole: UserRole;
}

/**
 * A wrapper component that provides role-based permissions context to the application
 * This component handles assigning the correct school IDs based on the user role
 */
const AppPermissionWrapper: React.FC<AppPermissionWrapperProps> = ({ children, userRole }) => {
  // In a real application, these would be fetched from an API
  // For now, we're hardcoding some sample school IDs for the SchoolAdmin
  const getAssignedSchoolIds = () => {
    if (userRole === 'SchoolAdmin') {
      return ['school-001', 'school-002'];
    }
    return [];
  };

  return (
    <PermissionProvider 
      userRole={userRole} 
      assignedSchoolIds={getAssignedSchoolIds()}
    >
      {children}
    </PermissionProvider>
  );
};

export default AppPermissionWrapper;
